export default "__VITE_ASSET__gMqyFmEg__"